module.exports = __webpack_public_path__ + "static/media/uva_big.755eb085.png";